import { Navigate } from 'react-router-dom';
import { useSession } from './useSession';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useSession();

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner" />
        <span>Cargando…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
